import $ from 'jquery';

/**
 * Data sources management module
 * Handles database connections and related functionality
 */

// Track currently loaded data sources
let dataSources = [];
let currentDataSourceId = null;

// Initialize data sources component
function initDataSources() {
  setupDataSourcesDialogs();
  loadUserDataSources();
  setupDataSourceForm();
  setupTablesList();
  setupConnectionStringValidator();

  // Initialize table scanner if available
  if (window.TableScanner) {
    TableScanner.init();
  }
}

// Set up dialogs for data sources functionality
function setupDataSourcesDialogs() {
  // Add data source dialog
  $('#add-data-source-btn').click(function (event) {
    var dialog = document.getElementById('add-data-source-dialog');
    dialog.showModal();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  // Test connection button handler
  $('#test-connection-btn').click(function (event) {
    testConnection();
    event.preventDefault();
    return false;
  });

  // Close dialog buttons
  $('.close-data-source-dialog').click(function (event) {
    var dialog = $(this).parents('dialog').get(0);
    dialog.close();
    event.preventDefault();
    event.stopPropagation();
    return false;
  });
}

// Load user's data sources
function loadUserDataSources() {
  // Show loading indicator in the tree view
  $('#dataSourcesTreeView').html(
    '<div class="loading-sources"><div class="mdl-spinner mdl-js-spinner is-active"></div><div>Loading database connections...</div></div>'
  );

  // Make sure MDL upgrades the spinner
  if (window.componentHandler) {
    window.componentHandler.upgradeElements($('#dataSourcesTreeView').find('.mdl-spinner').get());
  }

  $.ajax({
    url: '/api/data-sources',
    type: 'GET',
    data: {
      secret: userData.secret
    },
    success: function (response) {
      if (response.success === false) {
        $('#dataSourcesTreeView').html(
          '<div class="error-message">Error: ' +
            (response.error || 'Failed to load data sources') +
            '</div>'
        );
        console.error('Error loading data sources:', response.error);
        return;
      }

      dataSources = (response.data_sources || []).filter(
        source => (source.source_type || '').toLowerCase() !== 'sqlite'
      );

      // If no data sources, show helpful message
      if (dataSources.length === 0) {
        $('#dataSourcesTreeView').html(`
          <div class="no-data-sources">
            <p>No database connections added yet</p>
            <button id="add-first-data-source" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored">
              Add Database Connection
            </button>
          </div>
        `);

        // Add click handler for the add button
        $('#add-first-data-source').click(function () {
          var dialog = document.getElementById('add-data-source-dialog');
          dialog.showModal();
        });

        return;
      }

      renderDataSourcesTreeView();
    },
    error: function (error) {
      console.error('Error loading data sources:', error);
      $('#dataSourcesTreeView').html(`
        <div class="error-message">
          <p>Error loading database connections</p>
          <button id="retry-load-sources" class="mdl-button mdl-js-button mdl-button--raised">
            Retry
          </button>
        </div>
      `);

      // Add click handler for retry button
      $('#retry-load-sources').click(function () {
        loadUserDataSources();
      });
    }
  });
}

// Render data sources tree view
function renderDataSourcesTreeView() {
  let $treeView = $('#dataSourcesTreeView');
  $treeView.empty();

  if (!dataSources || dataSources.length === 0) {
    $treeView.append('<div class="no-data-sources">No database connections added yet</div>');
    return;
  }

  let $ul = $('<ul class="treeView"></ul>');

  // Group data sources by type
  const sourcesByType = {};
  dataSources.forEach(source => {
    // Normalize source type for display
    let displayType = source.source_type.toLowerCase();
    if (displayType === 'postgres' || displayType === 'postgresql') {
      displayType = 'postgresql';
    } else if (displayType === 'mysql' || displayType === 'mariadb') {
      displayType = 'mysql';
    } else if (displayType === 'mssql' || displayType === 'sqlserver') {
      displayType = 'sqlserver';
    }

    if (!sourcesByType[displayType]) {
      sourcesByType[displayType] = [];
    }
    sourcesByType[displayType].push(source);
  });

  // Get source type icon
  function getDbTypeIcon(sourceType) {
    const typeIcons = {
      postgresql: 'dns',
      mysql: 'storage',
      sqlserver: 'dns',
      oracle: 'dns'
    };
    return typeIcons[sourceType] || 'dns';
  }

  // Create tree structure with expandable tables
  Object.keys(sourcesByType).forEach(sourceType => {
    let $folder = $(`
      <li class="folder">
        <div class="folder-name">
          <i class="material-icons folder-icon">folder</i>
          <span>${sourceType.toUpperCase()}</span>
        </div>
        <ul class="folder-content"></ul>
      </li>
    `);

    const $folderContent = $folder.find('.folder-content');

    sourcesByType[sourceType].forEach(source => {
      let $source = $(`
        <li class="file data-source-item" data-source-id="${source.id}">
          <div class="file-wrapper">
            <i class="material-icons arrow-file-icon">${getDbTypeIcon(sourceType)}</i>
            <span class="file-name">${source.name}</span>
            <div class="file-actions">
              <i class="material-icons action-icon query-source" title="Query" data-source-id="${source.id}">search</i>
              <i class="material-icons action-icon view-tables" title="View Tables" data-source-id="${source.id}">table_chart</i>
            </div>
          </div>
          <ul class="source-tables" id="source-tables-${source.id}" style="display: none;"></ul>
        </li>
      `);

      $folderContent.append($source);
    });

    $ul.append($folder);
  });

  $treeView.append($ul);

  // Add click handlers for data source wrapper (expand/collapse tables)
  $treeView.find('.file-wrapper').click(function (e) {
    // Don't trigger if clicking action icons
    if ($(e.target).hasClass('action-icon') || $(e.target).parent().hasClass('action-icon')) {
      return;
    }

    const $sourceItem = $(this).parent();
    const sourceId = $sourceItem.data('source-id');
    const $tablesList = $sourceItem.find('.source-tables');

    // Toggle tables list
    if ($tablesList.is(':visible')) {
      $tablesList.slideUp(200);
      $sourceItem.removeClass('expanded');
    } else {
      // Load tables if not already loaded
      if ($tablesList.children().length === 0) {
        $tablesList.html('<li class="loading-tables">Loading tables...</li>');
        loadSourceTablesInSidebar(sourceId, $tablesList);
      }
      $tablesList.slideDown(200);
      $sourceItem.addClass('expanded');
    }
  });

  // Add action button handlers
  $treeView.find('.query-source').click(function (e) {
    e.stopPropagation();
    const sourceId = $(this).data('source-id');
    currentDataSourceId = sourceId;
    openQueryDialog(sourceId);
  });

  $treeView.find('.view-tables').click(function (e) {
    e.stopPropagation();
    const sourceId = $(this).data('source-id');
    selectDataSource(sourceId);
  });

  // Open all folders by default
  $treeView.find('.folder').addClass('open');

  // Add styles for the data sources treeview
  addDataSourcesStyles();

  // Add a count badge to the Data Sources header
  updateDataSourcesCount();
}

// Load tables for a data source and display in the sidebar
function loadSourceTablesInSidebar(sourceId, $tablesList) {
  // Show loading message
  $tablesList.html('<li class="loading-tables">Loading tables...</li>');

  // Get the data source from our cached list first
  const dataSource = dataSources.find(source => source.id === sourceId);

  // If we already have tables for this data source, use them
  if (dataSource && dataSource.tables && dataSource.tables.length > 0) {
    renderTablesList(dataSource.tables, $tablesList, sourceId);
    return;
  }

  // Otherwise, fetch tables from the server
  $.ajax({
    url: '/api/list-tables',
    type: 'GET',
    data: {
      secret: userData.secret,
      data_source_id: sourceId
    },
    success: function (response) {
      if (response.success === false) {
        $tablesList.html(
          `<li class="error-message">${response.error || 'Error loading tables'}</li>`
        );
        return;
      }

      // Cache tables in our local data source object
      const dataSourceIndex = dataSources.findIndex(source => source.id === sourceId);
      if (dataSourceIndex !== -1) {
        dataSources[dataSourceIndex].tables = response.tables || [];
      }

      renderTablesList(response.tables, $tablesList, sourceId);
    },
    error: function (error) {
      console.error('Error loading tables:', error);
      $tablesList.html('<li class="error-message">Error loading tables</li>');

      // Add a retry button
      $tablesList.append(`
        <li class="retry-button">
          <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored" 
                  onclick="loadSourceTablesInSidebar('${sourceId}', $('#source-tables-${sourceId}'))">
            Retry
          </button>
        </li>
      `);
    }
  });
}

// Render tables list into the provided container
function renderTablesList(tables, $tablesList, sourceId) {
  $tablesList.empty();

  if (!tables || tables.length === 0) {
    $tablesList.html('<li class="no-tables">No tables found</li>');
    return;
  }

  // Sort tables alphabetically
  tables.sort();

  // Group tables by schema if they use schema.table format
  const tablesBySchema = {};
  const regularTables = [];

  tables.forEach(table => {
    if (table.includes('.')) {
      const [schema, tableName] = table.split('.');
      if (!tablesBySchema[schema]) {
        tablesBySchema[schema] = [];
      }
      tablesBySchema[schema].push(tableName);
    } else {
      regularTables.push(table);
    }
  });

  // Add schema folders first if any
  if (Object.keys(tablesBySchema).length > 0) {
    Object.keys(tablesBySchema)
      .sort()
      .forEach(schema => {
        const $schemaFolder = $(`
        <li class="schema-folder">
          <div class="schema-name">
            <i class="material-icons folder-icon">folder</i>
            <span>${schema}</span>
          </div>
          <ul class="schema-tables"></ul>
        </li>
      `);

        const $schemaTables = $schemaFolder.find('.schema-tables');

        // Add tables to this schema
        tablesBySchema[schema].forEach(tableName => {
          const fullTableName = `${schema}.${tableName}`;
          const $tableItem = $(`
          <li class="table-item" data-table-name="${fullTableName}" data-schema="${schema}">
            <i class="material-icons table-icon">table_chart</i>
            <span>${tableName}</span>
          </li>
        `);

          $schemaTables.append($tableItem);
        });

        $tablesList.append($schemaFolder);
      });

    // Add schema folder toggle behavior
    $tablesList.find('.schema-name').click(function (e) {
      e.stopPropagation();
      $(this).parent().toggleClass('open');
    });

    // Open schema folders by default
    $tablesList.find('.schema-folder').addClass('open');
  }

  // Add regular tables
  regularTables.forEach(table => {
    const $tableItem = $(`
      <li class="table-item" data-table-name="${table}">
        <i class="material-icons table-icon">table_chart</i>
        <span>${table}</span>
      </li>
    `);

    $tablesList.append($tableItem);
  });

  // Add click handler for tables to query them
  $tablesList.find('.table-item').click(function (e) {
    e.stopPropagation();
    const tableName = $(this).data('table-name');
    currentDataSourceId = sourceId;
    queryTable(tableName);
  });

  // Add schema folder styles if not already added
  if (Object.keys(tablesBySchema).length > 0 && !$('#schema-folder-styles').length) {
    $('head').append(`
      <style id="schema-folder-styles">
        .schema-folder {
          margin-bottom: 5px;
        }
        
        .schema-name {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 3px 5px;
          border-radius: 4px;
        }
        
        .schema-name:hover {
          background-color: rgba(158, 158, 158, 0.2);
        }
        
        .schema-tables {
          display: none;
          margin-left: 20px;
          padding-left: 0;
          list-style-type: none;
        }
        
        .schema-folder.open .schema-tables {
          display: block;
        }
        
        .folder-icon {
          font-size: 16px;
          margin-right: 5px;
          color: rgba(0, 0, 0, 0.54);
        }
      </style>
    `);
  }
}

// Open query dialog directly
function openQueryDialog(sourceId) {
  currentDataSourceId = sourceId;
  const dialog = document.getElementById('query-data-source-dialog');
  dialog.showModal();

  // Clear previous query
  $('#query-data-source-input').val('');
  $('#query-results').empty();
}

// Add CSS styles for the data sources treeview
function addDataSourcesStyles() {
  // Check if styles already added
  if ($('#data-sources-styles').length) return;

  const styles = `
    <style id="data-sources-styles">
      #dataSourcesTreeView .folder {
        margin-bottom: 5px;
      }
      
      #dataSourcesTreeView .data-source-item {
        position: relative;
        margin-bottom: 3px;
      }
      
      #dataSourcesTreeView .file-wrapper {
        display: flex;
        align-items: center;
        padding: 5px;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.2s;
      }
      
      #dataSourcesTreeView .file-wrapper:hover {
        background-color: rgba(158, 158, 158, 0.2);
      }
      
      #dataSourcesTreeView .file-actions {
        display: none;
        margin-left: auto;
      }
      
      #dataSourcesTreeView .file-wrapper:hover .file-actions {
        display: flex;
      }
      
      #dataSourcesTreeView .action-icon {
        font-size: 18px;
        margin-left: 5px;
        color: rgba(0, 0, 0, 0.54);
        cursor: pointer;
      }
      
      #dataSourcesTreeView .action-icon:hover {
        color: #673ab7;
      }
      
      #dataSourcesTreeView .source-tables {
        margin-left: 25px;
        padding-left: 0;
        list-style-type: none;
      }
      
      #dataSourcesTreeView .table-item {
        display: flex;
        align-items: center;
        padding: 3px 5px;
        font-size: 13px;
        cursor: pointer;
        border-radius: 4px;
      }
      
      #dataSourcesTreeView .table-item:hover {
        background-color: rgba(158, 158, 158, 0.2);
      }
      
      #dataSourcesTreeView .table-icon {
        font-size: 16px;
        margin-right: 5px;
        color: rgba(0, 0, 0, 0.54);
      }
      
      #dataSourcesTreeView .loading-tables,
      #dataSourcesTreeView .no-tables,
      #dataSourcesTreeView .error-message {
        margin-left: 25px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.54);
        padding: 3px 0;
      }
      
      #dataSourcesTreeView .error-message {
        color: #f44336;
      }
      
      #dataSourcesTreeView .loading-sources {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        color: rgba(0, 0, 0, 0.54);
        font-size: 14px;
      }
      
      #dataSourcesTreeView .loading-sources .mdl-spinner {
        margin-bottom: 10px;
      }
      
      #dataSourcesTreeView .no-data-sources {
        padding: 15px;
        text-align: center;
        color: rgba(0, 0, 0, 0.54);
      }
      
      #dataSourcesTreeView .no-data-sources p {
        margin-bottom: 15px;
      }
      
      #dataSourcesTreeView .retry-button {
        margin-top: 5px;
        margin-left: 25px;
      }
      
      #dataSourcesTreeView .data-source-item.expanded .file-wrapper {
        background-color: rgba(158, 158, 158, 0.1);
      }
    </style>
  `;

  $('head').append(styles);
}

// Set up data source form
function setupDataSourceForm() {
  // Source type change handler
  $('#data-source-type').change(function () {
    const sourceType = $(this).val();
    updatePortDefaults(sourceType);
  });

  // Form submission handler
  $('#add-data-source-form').submit(function (event) {
    event.preventDefault();
    saveDataSource();
    return false;
  });
}

// Update port defaults based on selected database type
function updatePortDefaults(sourceType) {
  let defaultPort = '5432'; // Default for postgres

  if (sourceType === 'mysql') {
    defaultPort = '3306';
  } else if (sourceType === 'mssql') {
    defaultPort = '1433';
  }

  $('#data-source-port').val(defaultPort);
}

// Save new data source
function performTestConnection(sourceData) {
  return new Promise(function (resolve) {
    $.ajax({
      url: '/api/test-connection',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(sourceData),
      success: function (response) {
        resolve(response.success ? true : response.error || 'Connection failed');
      },
      error: function () {
        resolve('Error testing connection');
      }
    });
  });
}

function saveDataSource() {
  const form = $('#add-data-source-form');
  const connectionString = $('#connection-string').val().trim();

  const sourceData = {
    secret: userData.secret,
    name: $('#data-source-name').val(),
    source_type: $('#data-source-type').val(),
    username: $('#data-source-username').val(),
    password: $('#data-source-password').val(),
    host: $('#data-source-host').val(),
    port: $('#data-source-port').val(),
    database: $('#data-source-database').val(),
    db_schema: $('#data-source-schema').val(),
    connection_string: connectionString
  };

  // Basic validation - either connection string or standard fields
  if (connectionString) {
    // If using connection string, only name is required
    if (!sourceData.name) {
      showSnackbar('Please provide a name for this connection');
      return;
    }
  } else {
    // Standard validation for manual connection details
    if (!sourceData.name || !sourceData.username || !sourceData.host || !sourceData.database) {
      showSnackbar('Please fill in all required fields');
      return;
    }
  }

  form.find('.progress').show();
  performTestConnection(sourceData).then(function (result) {
    if (result !== true) {
      form.find('.progress').hide();
      $('#test-connection-result').html(`<div class="error-message">${result}</div>`);
      return;
    }

    $.ajax({
      url: '/api/data-sources',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(sourceData),
      success: function (response) {
        form.find('.progress').hide();
        if (response.success) {
          showSnackbar('Data source added successfully');
          form[0].reset();
          document.getElementById('add-data-source-dialog').close();
          loadUserDataSources();
        } else {
          showSnackbar('Error: ' + (response.error || 'Failed to add data source'));
        }
      },
      error: function (error) {
        form.find('.progress').hide();
        console.error('Error adding data source:', error);
        showSnackbar('Error adding data source');
      }
    });
  });
}

// Test database connection
function testConnection() {
  const sourceData = {
    secret: userData.secret,
    name: $('#data-source-name').val(),
    source_type: $('#data-source-type').val(),
    username: $('#data-source-username').val(),
    password: $('#data-source-password').val(),
    host: $('#data-source-host').val(),
    port: $('#data-source-port').val(),
    database: $('#data-source-database').val(),
    schema: $('#data-source-schema').val()
  };

  $('#test-connection-btn').prop('disabled', true);
  $('#test-connection-result').empty();

  performTestConnection(sourceData).then(function (result) {
    $('#test-connection-btn').prop('disabled', false);
    if (result === true) {
      $('#test-connection-result').html(
        '<div class="success-message">Connection successful!</div>'
      );
    } else {
      $('#test-connection-result').html(`<div class="error-message">${result}</div>`);
    }
  });
}

// Select a data source and show its tables
function selectDataSource(sourceId) {
  $('#dataSourcesTreeView .file').removeClass('active');
  $(`#dataSourcesTreeView .file[data-source-id="${sourceId}"]`).addClass('active');

  currentDataSourceId = sourceId;
  loadSourceTables(sourceId);

  // Show tables dialog
  document.getElementById('data-source-tables-dialog').showModal();
}

// Set up tables list
function setupTablesList() {
  // Table click handler for querying
  $(document).on('click', '#data-source-tables .table-item', function () {
    const tableName = $(this).data('table-name');
    queryTable(tableName);
  });
}

// Load tables for selected data source
function loadSourceTables(sourceId) {
  const $tablesList = $('#data-source-tables');
  $tablesList.html('<div class="loading-tables">Loading tables...</div>');

  $.ajax({
    url: '/api/list-tables',
    type: 'GET',
    data: {
      secret: userData.secret,
      data_source_id: sourceId
    },
    success: function (response) {
      $tablesList.empty();

      if (!response.tables || response.tables.length === 0) {
        $tablesList.html('<div class="no-tables">No tables found</div>');
        return;
      }

      response.tables.forEach(table => {
        const $tableItem = $(`
          <div class="table-item" data-table-name="${table}" data-table="${table}" data-source="${sourceId}">
            <i class="material-icons">table_chart</i>
            <span>${table}</span>
          </div>
        `);

        $tablesList.append($tableItem);
      });

      // Add table scanner buttons if available
      if (window.TableScanner) {
        TableScanner.addScanButtons();
      }
    },
    error: function (error) {
      console.error('Error loading tables:', error);
      $tablesList.html('<div class="error-message">Error loading tables</div>');
    }
  });
}

// Setup the edit form for database table queries
function setupDatabaseEditForm(dataSource, tableName) {
  // Override the form submit to handle database queries
  const $form = $('#editdataaskfelixform');

  // Remove any existing handlers first
  $form.off('submit.database');

  // Add new handler for database queries
  $form.on('submit.database', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const query = $('#editdataquery').val();
    if (!query) return false;

    if (window.NativeDatasetEditor && typeof window.NativeDatasetEditor.runDatabaseQuery === 'function') {
      window.NativeDatasetEditor.runDatabaseQuery(dataSource, tableName, query);
      return false;
    }

    // Execute query against the database table
    $.ajax({
      url: '/api/query-data-source',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        secret: window.userData?.secret || localStorage.getItem('secret'),
        data_source_id: dataSource.id,
        query: query,
        table_context: tableName,
        natural_language: true
      }),
      success: function (response) {
        if (response.success) {
          // Show success message
          showSnackbar('Query executed successfully');
        } else {
          showSnackbar('Error: ' + (response.error || 'Query failed'));
        }
      },
      error: function (xhr, status, error) {
        console.error('Query error:', error);
        showSnackbar('Error executing query: ' + error);
      }
    });

    return false;
  });

  // Update the dialog title to show table context
  const dialogTitle = document.querySelector('#edit-data-dialog .mdl-dialog__title');
  if (dialogTitle) {
    dialogTitle.textContent = `Edit Data - ${dataSource.name}: ${tableName}`;
  }

  // Pre-fill with a sample query
  $('#editdataquery').attr(
    'placeholder',
    'e.g., "Show all records" or "Filter where status = \'active\'"'
  );
}

// Open edit data dialog for a database table
function openEditDataDialogForTable(dataSource, tableName) {
  // Open the edit data dialog
  const dialog = document.getElementById('edit-data-dialog');
  if (!dialog) {
    console.error('Edit data dialog not found');
    return;
  }

  if (dialog.open) dialog.close();
  dialog.showModal();

  if (window.NativeDatasetEditor && typeof window.NativeDatasetEditor.openDatabaseTable === 'function') {
    window.NativeDatasetEditor.openDatabaseTable(dataSource, tableName);
  }

  // Store current editing context
  window.currentEditingDataSource = dataSource;
  window.currentEditingTable = tableName;

  // Update the form to handle database queries
  setupDatabaseEditForm(dataSource, tableName);
}

// Query a specific table
function queryTable(tableName) {
  if (!currentDataSourceId) return;

  // Get the data source details
  const dataSource = dataSources.find(source => source.id === currentDataSourceId);
  if (!dataSource) return;

  // Open the edit data dialog instead of query dialog
  openEditDataDialogForTable(dataSource, tableName);
}

// Execute SQL query
function executeQuery(visualization = false, tables = null) {
  const query = $('#query-data-source-input').val();

  if (!query || !currentDataSourceId) return;

  const $results = $('#query-results');
  $results.html('<div class="loading-results">Executing query...</div>');

  let requestData = {
    secret: userData.secret,
    data_source_id: currentDataSourceId,
    query: query,
    visualization: visualization
  };

  // Add table context if provided
  if (tables && Array.isArray(tables) && tables.length > 0) {
    requestData.tables = tables;
  }

  $.ajax({
    url: '/api/query-data-source',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify(requestData),
    success: function (response) {
      if (response.error) {
        $results.html(`<div class="error-message">Query error: ${response.error}</div>`);
        return;
      }

      // If it's a visualization response, handle differently
      if (visualization && response.data && response.metadata) {
        renderVisualization(response);
      } else {
        renderQueryResults(response.data || response);

        // Show execution time if available
        if (response.execution_time) {
          $results.append(
            `<div class="execution-info">Execution time: ${response.execution_time}</div>`
          );
        }
      }
    },
    error: function (error) {
      console.error('Error executing query:', error);
      $results.html('<div class="error-message">Error executing query</div>');
    }
  });
}

// Render query results as table
function renderQueryResults(data) {
  const $results = $('#query-results');
  $results.empty();

  if (!data || !data.length) {
    $results.html('<div class="no-results">Query returned no results</div>');
    return;
  }

  // Create table
  const $table = $('<table class="query-results-table"></table>');

  // Create header
  const $header = $('<tr></tr>');
  Object.keys(data[0]).forEach(key => {
    $header.append(`<th>${key}</th>`);
  });
  $table.append($('<thead></thead>').append($header));

  // Create rows
  const $tbody = $('<tbody></tbody>');
  data.forEach(row => {
    const $tr = $('<tr></tr>');
    Object.values(row).forEach(value => {
      $tr.append(`<td>${value !== null ? value : 'NULL'}</td>`);
    });
    $tbody.append($tr);
  });
  $table.append($tbody);

  $results.append($table);
}

// Setup connection string validator
function setupConnectionStringValidator() {
  // Set up the validate connection string button click handler
  $('#validate-connection-string').click(function (event) {
    validateConnectionString();
    event.preventDefault();
    return false;
  });

  // Handle tab switching to ensure proper form validation
  $('.mdl-tabs__tab').click(function () {
    const targetPanel = $(this).attr('href');

    // Update form validation requirements based on active tab
    if (targetPanel === '#connection-string-panel') {
      // When using connection string, make standard fields not required
      $(
        '#data-source-host, #data-source-username, #data-source-password, #data-source-database'
      ).prop('required', false);
    } else {
      // When using standard connection, restore required attributes
      $(
        '#data-source-host, #data-source-username, #data-source-password, #data-source-database'
      ).prop('required', true);
    }
  });
}

// Validate connection string
function validateConnectionString() {
  const connectionString = $('#connection-string').val().trim();

  if (!connectionString) {
    $('#connection-string-result').html(
      '<div class="error-message">Please enter a connection string</div>'
    );
    return;
  }

  $('#validate-connection-string').prop('disabled', true);
  $('#connection-string-result').html(
    '<div class="loading-message">Validating connection string...</div>'
  );

  $.ajax({
    url: '/api/validate-connection-string',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
      secret: userData.secret,
      connection_string: connectionString
    }),
    success: function (response) {
      $('#validate-connection-string').prop('disabled', false);

      if (response.success) {
        $('#connection-string-result').html(
          `<div class="success-message">${response.message}</div>`
        );

        // Auto-fill the connection string in the data source form
        $('#data-source-connection-string').val(connectionString);

        // Try to extract database type and name from connection string for user convenience
        let dbType = '';
        if (connectionString.includes('postgresql')) {
          dbType = 'postgres';
        } else if (connectionString.includes('mysql')) {
          dbType = 'mysql';
        } else if (connectionString.includes('mssql')) {
          dbType = 'mssql';
        }

        if (dbType) {
          $('#data-source-type').val(dbType);
        }

        // Extract database name from connection string (very basic extraction)
        const dbNameMatch = connectionString.match(/\/([^\/\?]+)(\?|$)/);
        if (dbNameMatch && dbNameMatch[1]) {
          const dbName = dbNameMatch[1];
          $('#data-source-database').val(dbName);

          // Suggest a name for the data source
          if (!$('#data-source-name').val()) {
            $('#data-source-name').val(dbName + ' connection');
          }
        }
      } else {
        $('#connection-string-result').html(
          `<div class="error-message">Connection failed: ${response.error}</div>`
        );
      }
    },
    error: function (error) {
      $('#validate-connection-string').prop('disabled', false);
      console.error('Error validating connection string:', error);
      $('#connection-string-result').html(
        '<div class="error-message">Error validating connection string</div>'
      );
    }
  });
}

// Update the count badge on the Data Sources header
function updateDataSourcesCount() {
  const count = dataSources ? dataSources.length : 0;

  // Find or create the badge element
  let $badge = $('.datasources-header .count-badge');
  if (!$badge.length) {
    $badge = $('<span class="count-badge"></span>');
    $('.datasources-header').append($badge);

    // Add badge styles if not already present
    if (!$('#count-badge-styles').length) {
      $('head').append(`
        <style id="count-badge-styles">
          .count-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            border-radius: 10px;
            background-color: #673ab7;
            color: white;
            font-size: 12px;
            margin-left: 8px;
            padding: 0 6px;
          }
        </style>
      `);
    }
  }

  // Update the badge count
  $badge.text(count);
}

// Show a snackbar notification message
function showSnackbar(message, actionText = null, actionHandler = null) {
  // Check if MDL snackbar is available
  const snackbarElement = document.getElementById('share-snackbar');
  if (snackbarElement && snackbarElement.MaterialSnackbar) {
    const data = {
      message: message,
      timeout: 2750
    };

    if (actionText && actionHandler) {
      data.actionText = actionText;
      data.actionHandler = actionHandler;
    }

    snackbarElement.MaterialSnackbar.showSnackbar(data);
    return;
  }

  // Simple fallback if MDL snackbar not available
  alert(message);
}

// Update the main search bar with database context
function updateMainQueryBar(dataSource, tableName) {
  // Find the main query input
  const $mainQuery = $('#query');
  if (!$mainQuery.length) return;

  // Provide hint text for database querying
  $mainQuery.attr(
    'placeholder',
    `Ask about ${dataSource.name} ${tableName} table (e.g., "Show me a chart of ${tableName} data")`
  );

  // Store the active data source and table for Helix to use
  window.activeDataSource = {
    id: dataSource.id,
    name: dataSource.name,
    table: tableName
  };

  // Add visual indicator to the query bar
  updateQueryBarSourceIndicator(dataSource, tableName);

  // Show a brief notification that we're now using this data source
  showSnackbar(`Now using ${dataSource.name} - ${tableName} for queries`);
}

// Add visual indicator to the query bar that a data source is active
function updateQueryBarSourceIndicator(dataSource, tableName) {
  // Remove any existing indicator
  $('#db-source-indicator').remove();

  // Create the indicator
  const $indicator = $(`
    <div id="db-source-indicator" class="db-source-indicator">
      <i class="material-icons">dns</i>
      <span>${dataSource.name}: ${tableName}</span>
      <i class="material-icons clear-source">clear</i>
    </div>
  `);

  // Add indicator to the page
  $('#query').before($indicator);

  // Add styles if needed
  if (!$('#db-source-indicator-styles').length) {
    $('head').append(`
      <style id="db-source-indicator-styles">
        .db-source-indicator {
          display: flex;
          align-items: center;
          margin-right: 8px;
          padding: 4px 8px;
          background-color: #e0e0e0;
          border-radius: 16px;
          font-size: 13px;
          font-weight: 500;
          color: #673ab7;
        }
        
        .db-source-indicator .material-icons {
          font-size: 16px;
          margin-right: 4px;
        }
        
        .db-source-indicator .clear-source {
          cursor: pointer;
          font-size: 14px;
          margin-left: 4px;
          opacity: 0.7;
        }
        
        .db-source-indicator .clear-source:hover {
          opacity: 1;
        }
        
        /* Adjust query input to make room for indicator */
        #remote {
          display: flex;
          align-items: flex-start;
        }
      </style>
    `);
  }

  // Add click handler to clear button
  $('.clear-source').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Clear the active data source
    window.activeDataSource = null;

    // Remove the indicator
    $('#db-source-indicator').remove();

    // Reset the query placeholder
    $('#query').attr('placeholder', 'Helix');

    // Show notification
    showSnackbar('Database context cleared');

    return false;
  });
}

// Initialize on document ready
$(document).ready(function () {
  // The SQL workbench has its own data-source loader and intentionally reuses
  // this tree id. Do not race it with the legacy sidebar loader (or make a
  // duplicate authenticated request while the workbench auth state settles).
  const hasWorkbenchOwner = document.getElementById('sql-workbench-page') !== null;
  if ($('#dataSourcesTreeView').length && !hasWorkbenchOwner) {
    initDataSources();
  }
});
// Perform natural language query
function naturalLanguageQuery() {
  const query = $('#query-data-source-input').val();

  if (!query || !currentDataSourceId) return;

  // Get currently selected table for context if available
  let tables = [];
  if (currentTable) {
    tables.push(currentTable);
  }

  // Execute the natural language query with visualization
  executeQuery(true, tables);
}

// Render visualization from API response
function renderVisualization(response) {
  const $results = $('#query-results');
  $results.empty();

  // If response has data and layout, render Plotly chart
  if (response.data && (response.layout || response.metadata)) {
    // Create container for the visualization
    const $vizContainer = $('<div class="visualization-container"></div>');
    $results.append($vizContainer);

    // Create Plotly visualization
    Plotly.newPlot($vizContainer[0], response.data, response.layout || {});

    // Add execution time if available
    if (response.metadata && response.metadata.execution_time) {
      $results.append(
        `<div class="execution-info">Execution time: ${response.metadata.execution_time}</div>`
      );
    }
  } else {
    // Fallback to standard results display
    renderQueryResults(response.data || []);
  }
}
